import React from "react";
import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
// import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import moment from "moment";
import states from './states.json';

// https://mui.com/material-ui/react-card/
export default function HotlineMessage({ msg }) {
  const { fromName, toName, created, text, fromGeo } = msg;
  const time = moment(created);
  const fromTag = fromName ? `From ${fromName.trim()}` : "";
  const toTag = toName ? `To ${toName.trim()}, ` : "";
  const {
    // city,
    country,
    state,
    // zip 
  } = fromGeo;
  let fromGeoTag = "";
  // if (city && state) fromGeoTag += `${city}, ${state}`;
  // else 
  if (state) {
    const displayState = states[state] ?? state;
    fromGeoTag += `${displayState}`;
  }
  if (!["USA", "US", "United States", null].includes(country)) {
    fromGeoTag += ` ${country}`
  }


  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {`${toTag}${time.fromNow()}`}
        </Typography>
        <Typography variant="h5" component="div" gutterBottom sx={{maxHeight: 300, overflow: 'auto'}}>
          {text}
        </Typography>
        <Box display="flex" justifyContent="space-between">
          <Typography
            sx={{ fontSize: 14 }}
            color="text.secondary"
            component="span"
          >
            {fromTag}
          </Typography>
          <Typography
            sx={{ fontSize: 14 }}
            color="text.secondary"
            component="span"
          >
            {fromGeoTag}
          </Typography>
        </Box>
      </CardContent>
      {/* <CardActions>
        <Button size="small">LIKE</Button>
      </CardActions> */}
    </Card>
  );
}
